import { Dispatch } from "redux";
import api from "../../api/api";

export const FETCH_DEPARTMENT_REQUEST = "FETCH_DEPARTMENT_REQUEST";
export const FETCH_DEPARTMENT_SUCCESS = "FETCH_DEPARTMENT_SUCCESS";
export const FETCH_DEPARTMENT_FAILURE = "FETCH_DEPARTMENT_FAILURE";

export const VIEW_DEPARTMENT_REQUEST = "VIEW_DEPARTMENT_REQUEST";
export const VIEW_DEPARTMENT_SUCCESS = "VIEW_DEPARTMENT_SUCCESS";
export const VIEW_DEPARTMENT_FAILURE = "VIEW_DEPARTMENT_FAILURE";

export const RESET_DEPARTMENT_DETAILS = "RESET_DEPARTMENT_DETAILS";


// TYPES
interface FetchDepartmentRequestAction {
  type: typeof FETCH_DEPARTMENT_REQUEST;
}

interface FetchDepartmentSuccessAction {
  type: typeof FETCH_DEPARTMENT_SUCCESS;
  payload: {
    data:  any[];
    total: number;
  };
}

interface FetchDepartmentFailureAction {
  type: typeof FETCH_DEPARTMENT_FAILURE;
  payload: string;
}

interface ViewDepartmentRequestAction {
  type: typeof VIEW_DEPARTMENT_REQUEST;
}

interface ViewDepartmentSuccessAction {
  type: typeof VIEW_DEPARTMENT_SUCCESS;
   payload: {
    data: any[];
    total: number;
  };
}

interface ViewDepartmentFailureAction {
  type: typeof VIEW_DEPARTMENT_FAILURE;
  payload: string;
}
interface ResetDepartmentDetailsAction {
  type: typeof RESET_DEPARTMENT_DETAILS;
}

interface ViewDepartmentFilters {
  page?: number;
  pageSize?: number;
  search?: string;
  school_id?:number
}

interface DepartmentFilters {
  page?: number;
  pageSize?: number;
  search?: string;
  school_id?:number
}

export type DepartmentActionTypes =
  | FetchDepartmentRequestAction
  | FetchDepartmentSuccessAction
  | FetchDepartmentFailureAction
  | ViewDepartmentRequestAction
  | ViewDepartmentSuccessAction
  | ViewDepartmentFailureAction
  | ResetDepartmentDetailsAction

export const resetDepartmentDetails = () => ({
  type: RESET_DEPARTMENT_DETAILS as typeof RESET_DEPARTMENT_DETAILS,
});

// FETCH DEPARTMENTS
export const fetchDepartmentActions =
  (token: string, sort?: string,  filters: DepartmentFilters = {}) => async (dispatch: Dispatch<DepartmentActionTypes>) => {
    try {
      dispatch({ type: FETCH_DEPARTMENT_REQUEST });

      const params = new URLSearchParams({ type: "departments" });
      if (sort)             params.append("sort",      sort);
      if (filters.search)   params.append("search",    filters.search);
      if (filters.page)     params.append("page",      String(filters.page));
      if (filters.pageSize) params.append("page_size", String(filters.pageSize));
      if (filters.school_id) params.append("school_id", String(filters.school_id)); 

      const response = await api.get(
        `/adminpage/access-control/hod/?${params.toString()}`,
        {
          headers: {
            Authorization: `Token ${token}`,
          },
        }
      );

      dispatch({
        type: FETCH_DEPARTMENT_SUCCESS,
        payload: {
          data:  response?.data?.data,
          total: response?.data?.total ?? response?.data?.count ?? 0,
        },
      });
    } catch (error: any) {
      dispatch({
        type: FETCH_DEPARTMENT_FAILURE,
        payload: error.message,
      });
    }
  };


// VIEW DEPARTMENT
export const viewDepartmentAction =
  (subjectId: string, token: string, sort?: string,  filters: ViewDepartmentFilters = {}) =>
  async (dispatch: Dispatch<DepartmentActionTypes>) => {
    try {
      dispatch({ type: VIEW_DEPARTMENT_REQUEST });

      const params = new URLSearchParams({ type: "view_department", subject_id: subjectId });
      if (sort)                params.append("sort",      sort);
      if (filters.search)      params.append("search",    filters.search);
      if (filters.page)        params.append("page",      String(filters.page));
      if (filters.pageSize)    params.append("page_size", String(filters.pageSize));
      if (filters.school_id) params.append("school_id", String(filters.school_id)); 
      

      const response = await api.get(
        `/adminpage/access-control/hod/?${params.toString()}`,
        {
          headers: {
            Authorization: `Token ${token}`,
          },
        }
      );
      console.log("RAW API RESPONSE:", response?.data); // ← add this


      dispatch({
        type: VIEW_DEPARTMENT_SUCCESS,
        payload: {
          data:  response?.data?.data,
          total: response?.data?.total ?? response?.data?.count ?? 0, // adjust key to match your API
        },
      });
    } catch (error: any) {
      dispatch({
        type: VIEW_DEPARTMENT_FAILURE,
        payload: error?.response?.data?.message || error.message,
      });
    }
  };